module.exports = {
  name: 'Peter Shamoun',
  email: 'petershamoun80@gmail.com',
  siteUrl: 'https://petershamoun.com',

  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/Peter-Shamoun',
    },
    {
      name: 'LinkedIn',
      url: 'https://www.linkedin.com/in/peter-shamoun',
    },
  ],

  colors: {
    bg: '#3a6ea5',
    chrome: '#C0C0C0',
  },
};
